module.exports = __webpack_public_path__ + "static/img/folia.bd54f697.webp";